import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { type FeedFlowItem, type Post } from '@src/services/interface';
import LinkFeed from '@src/mobile/components/tweet/linkFeed';
import ForwardShort from '@src/mobile/components/tweet/forwardShort';
import ForwardFeed from '@src/mobile/components/tweet/forwardFeed';

type TweetProps = {
    content: {
        isFeed: boolean;
        forwardStatus: FeedFlowItem['forwardStatus'];
        forwardItem: FeedFlowItem | null | undefined;
        post: Post | null | undefined;
        type?: FeedFlowItem['type'];
    };
};

const Tweet = ({ content }: TweetProps) => {
    const hasPostLink = content.post?.hasLink;
    const hasForward = content?.forwardStatus === 1;
    const forwardType = content?.forwardItem?.type;
    const linkFeedData = content.post;
    const forwardShortData = content?.forwardItem;
    const forwardFeedData = content?.forwardItem;

    return (
        <>
            {/* 显示左文右图 */}
            {hasPostLink && <LinkFeed content={linkFeedData} />}
            {/* 显示 用户信息+文字[视频][图片][投票]+link */}
            {hasForward && forwardType === 'short' && !hasPostLink && <ForwardShort content={forwardShortData} />}
            {/* 显示 用户信息+左文右图+link */}
            {hasForward && (forwardType === 'predict' || forwardType === 'translate') && !hasPostLink && (
                <ForwardFeed content={forwardFeedData} />
            )}
        </>
    );
};

export default errorBoundary(Tweet);
